import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Auth0Provider
		domain="aro-olive.us.auth0.com"
		clientId="P3TOcfBflaJbAzFajs987lPvxMdYAFWe"
		authorizationParams={{
			redirect_uri: window.location.origin,
			audience: "https://aro-olive.us.auth0.com/api/v2/",
			scope: "read:current_user update:current_user_metadata"
		}}
	>
		<App />
	</Auth0Provider>
);